import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Message {
    constructor(root) {
        this.root = root;
        this.container = this.root.querySelector('[data-message--container]');
        this.sentence = this.root.querySelector('[data-message--sentence]');

        this.bind();
        this.init();
    }

    bind() {
        this.onResize = this.onResize.bind(this);

        window.addEventListener('resize', this.onResize);
    }

    onResize() {
        this.swipeAnim = this.createSwipeAnim();
    }

    init() {
        this.appearAnim = gsap.fromTo(this.container, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
            scrollTrigger: {
              trigger: this.container,
              start: 'top 90%',
              end: 'bottom 10%',
              invalidateOnRefresh: true,
              // markers: true,
            },
        });

        this.swipeAnim = this.createSwipeAnim();
    }

    createSentences() {
        const span = this.sentence.querySelector('span');

        this.sentence.innerHTML = '';

        for (let i = 0; i < 5; i++) {
            this.sentence.innerHTML += `<span>${span.innerHTML}</span>`;
        }
    }

    createSwipeAnim() {
        this.swipeAnim && this.swipeAnim.kill();
        this.createSentences();

        const { width } = this.sentence.querySelector('span').getBoundingClientRect();

        const swipe = gsap.fromTo(this.sentence, {
            x: (-width * 2) - (48 * 2),
        }, {
            x: (-width * 3) - (48 * 3),
            repeat: -1,
            duration: 10,
            ease: 'linear',
        });

        return swipe;
    }

    destroy() {
        this.appearAnim.kill();
        this.swipeAnim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-message]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-message]').forEach(message => {
            const instance = new Message(message);
            this.instances.push(instance);
        })
    },
    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
